import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const pos = new Cwb_PositionalAttribute("pos", "Part-of-speech");

export const type = new Cwb_PositionalAttribute("type", "Type");

export const degrDia = new Cwb_PositionalAttribute("degr_dia", "Degree or voice");

export const tenseDefin = new Cwb_PositionalAttribute("tense_defin", "Tense or definiteness");

export const moodCase = new Cwb_PositionalAttribute("mood_case", "Mood or case");

export const personType2 = new Cwb_PositionalAttribute("person_type2", "Person or type 2");

export const number = new Cwb_PositionalAttribute("number", "Number");

export const gender = new Cwb_PositionalAttribute("gender", "Gender");

export const extra = new Cwb_PositionalAttribute("extra", "Extra");

export const list = ofArray([lemma, pos, type, degrDia, tenseDefin, moodCase, personType2, number, gender, extra]);

